import { CSSProperties } from "react";

import { useTheme } from "@hooks";

export const useStyles = (): Record<string, CSSProperties> => {
  const { theme } = useTheme();

  return {
    modalOption: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "16px 18px",
      borderRadius: 14,
      border: `1px solid ${theme.border}`,
      background: "none",
      fontFamily: "inherit",
      color: theme.text.default,
      textAlign: "left" as const,
      cursor: "pointer",
    },
    modalOptionSelected: {
      border: `2px solid ${theme.text.default}`,
      padding: "15px 17px",
    },
    modalOptionSubtitle: {
      color: theme.text.secondary,
    },
    discount: {
      marginLeft: "auto",
      fontSize: 12,
      fontWeight: 600,
      color: theme.text.default,
      background: theme.input.background,
      borderRadius: 999,
      padding: "4px 10px",
      flexShrink: 0,
    },
    modalFooter: {
      fontSize: 12,
      lineHeight: 1.5,
      color: theme.text.secondary,
    },
  };
};
